import session from "@/api/session";

const BASE_URL = 'telco/lines';

export default {
  fetchCliHistories(productId, opts) {
    return session.get(`/${BASE_URL}/${productId}/cli-history/`, opts);
  },
  changeCli(productId, data) {
    return session.post(`/${BASE_URL}/${productId}/actions/change-cli/`, JSON.stringify(data));
  },
  createNewAddress(productId) {
    return session.post(`/${BASE_URL}/${productId}/actions/create-address/`);
  }
}
